<template>
  <div class="text-center">
    <v-dialog v-model="dialog" xwidth="500">
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Tienes Preinscritos
        </v-card-title>

        <v-card-text>
          <p v-html="msg" class="green--text text-center mt-3"></p>
          <v-data-table
            :headers="headers"
            :items="preinscritos"
            :items-per-page="55"
            class="elevation-1"
          ></v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = !dialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        msg: '',
        headers: [
          { text: 'Num_doc', value: 'Num_doc' },
          { text: 'Estudiante', value: 'Estudiante' },
          { text: 'Programa', value: 'Nombre_compuesto' },
          { text: 'Pre inscrito', value: 'Fecha_registro' },
          //   { text: 'Gestion', value: 'Gestion' },
          { text: 'Sede', value: 'Sede' },
        ],
        preinscritos: [],
      };
    },
    methods: {
      openmodal(preinscritos, user) {
        window.console.log(preinscritos);
        this.preinscritos = preinscritos;
        let tam = preinscritos.length;
        if (tam > 0) {
          this.msg = `Hola <b class="red--text">${user}</b> Tienes <b class="red--text">${tam} preinscritos</b>, te recomendamos contactarte con tus preinscritos lo mas antes posible para poder inscribirlos, puedes ir a la opcion Marketing y luego en inscripciones ahi podras buscarlos por fechas, es posible que estos preinscritos lo hayas realizado tu o se hayan preinscrito por medio del formulario de preinscripcion, caso contrario eliminalos para no ver esta ventana.`;
          this.dialog = true;
        }
      },
    },
  };
</script>
